<template>
  <div class="rm-screen">
    <div class="rm-segment" role="tablist" :aria-label="$t('shifts')">
      <button
        v-for="segment in segments"
        :key="segment.key"
        type="button"
        role="tab"
        class="rm-segment__btn"
        :class="{ 'is-active': segment.active }"
        :aria-selected="String(segment.active)"
        @click="$emit('update:shifts', segment.shifts)"
      >
        {{ segment.label }}
      </button>
    </div>

    <div class="rm-summary">
      <div class="rm-summary__row">
        <div class="rm-summary__labels">
          <span>{{ summaryLabel }}</span>
          <span v-if="isCompaniesTab">{{ pluralT("report_mobile.companies_n", rows.length) }}</span>
        </div>
        <span class="rm-summary__value">{{ totals.total }}</span>
      </div>
    </div>

    <div v-if="loading" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>
    <template v-else-if="rows.length">
      <div v-for="row in rows" :key="row.key" class="rm-meal-row">
        <span class="rm-meal-row__text">
          <span class="rm-meal-row__name">{{ row.name }}</span>
          <span v-if="row.badges.length" class="rm-badges">
            <span v-for="badge in row.badges" :key="badge" class="rm-badge">{{ badge }}</span>
          </span>
        </span>
        <span class="rm-meal-row__count rm-num">{{ row.count }}</span>
      </div>
    </template>
    <div v-else class="rm-empty">{{ emptyText }}</div>
  </div>
</template>

<script>
import ReportTabAllCompaniesSummary from "@/components/report/tabs/ReportTabAllCompaniesSummary.vue";
import { SHIFTS } from "@/constants/shifts";
import hasPlural from "../hasPlural";
import hasShiftSegments from "../hasShiftSegments";

/**
 * Mobilni prikaz "Sve firme – zbirni izvještaj" (Obroci ili Firme): nasleđuje
 * učitavanje, štampu i Excel iz ReportTabAllCompaniesSummary.
 */
export default {
  name: "ReportMobileAllSummary",
  extends: ReportTabAllCompaniesSummary,
  mixins: [hasPlural, hasShiftSegments],
  props: {
    shifts: {
      type: Array,
      required: true,
    },
    /** "meals" ili "companies" */
    mode: {
      type: String,
      default: "meals",
    },
  },
  data() {
    return { tab: this.mode === "companies" ? 1 : 0 };
  },
  computed: {
    shiftTotals() {
      const rows = this.isCompaniesTab ? this.summary.companies : this.summary.items;
      return SHIFTS.reduce((totals, shift) => {
        totals[shift.id] = rows.reduce((sum, row) => sum + (row[shift.key] || 0), 0);
        return totals;
      }, {});
    },
    rows() {
      return this.customSearch(this.visibleRows, [{ value: "name" }], this.filters.search)
        .map((row) => ({
          key: row.id ?? row.name,
          name: row.name,
          count: row.total,
          badges: this.isCompaniesTab ? (row.sources || []).map(this.sourceLabel) : [],
        }))
        .sort((a, b) => b.count - a.count);
    },
    emptyText() {
      if (this.filters.search) {
        return this.$t("report_mobile.no_results_for", { search: this.filters.search });
      }
      return this.isSingleShift
        ? this.$t("report_mobile.no_meals_in_shift")
        : this.$t("report_mobile.no_meals");
    },
  },
  watch: {
    shifts: {
      handler(shifts) {
        this.selectedShifts = [...shifts];
      },
      immediate: true,
    },
  },
};
</script>
